"use client"
import { useTheme } from "@mui/material/styles"
import { FC } from "react"

import styles from "./PostHeaderSeperator.module.scss"

import { create } from "@/helpers/bem"

const bem = create(styles, "PostHeaderSeperator")

export const PostHeaderSeperator: FC = () => {
  const theme = useTheme()
  return (
    <span
      className={bem(undefined, {
        [theme.palette.mode]: true,
      })}
    >
      &mdash;&nbsp;&nbsp;
    </span>
  )
}
